/**
 * In-memory access token synced from `ApiContext` after `/tokens` (same pattern as myaccount shell).
 * Used by `queryClient` to attach `Authorization: Bearer` on booking admin API calls.
 */

let accessToken: string | null = null;

export function syncAccessTokenFromCredentials(c: { access_token?: string } | null | undefined): void {
  accessToken = c?.access_token ?? null;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function clearAccessToken(): void {
  accessToken = null;
}
